import { render, staticRenderFns } from "./CourseCertification.vue?vue&type=template&id=430b93d8"
import script from "./CourseCertification.vue?vue&type=script&lang=ts"
export * from "./CourseCertification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports